import { path } from 'ramda';

import API from 'app/api';
import { deviceId, deviceType, accessToken } from 'config/baseconfig';
import parseResponse from 'app/api/requests/parsers/response';
import { User } from 'app/api/entities/user';

const fetchUserData = () =>
  API.Crapi.fetchUserData({
    sess_id: 1,
    device_id: deviceId,
    device_type: deviceType,
    access_token: accessToken,
    referer: path(['location', 'href'], window),
  })
    .then(parseResponse)
    .then(User);

export { fetchUserData };
